import { useEffect, useState, useMemo } from "react";
import { getTenantContractData } from "@services/API/Requests/ContractRequests";
import { CONTRACT_STATUS } from "@constants/Enums";
import { useDispatch } from "react-redux";
import {
  addApp,
  setAppsCheckedState,
} from "@services/StateManagement/AppSlice";

export const useActiveApps = (companyId: string) => {
  const dispatch = useDispatch();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<String>("");

  useEffect(() => {
    const fetchApps = async () => {
      await getTenantContractData(
        setApps,
        setLoading,
        setError,
        companyId,
      ).then(() => {
        setApps((prevApps) => {
          const validApps = prevApps.filter(
            (app) => app.status === CONTRACT_STATUS.ACTIVE,
          );
          validApps.forEach((app) => {
            dispatch(addApp(app.app_name));
          });
          return validApps;
        });
        dispatch(setAppsCheckedState(true));
      });
    };

    fetchApps();
  }, [companyId]);

  return useMemo(() => ({ apps, loading }), [apps, loading]);
};
